// src/pages/AnalyticsPage.tsx
import React from "react";
import AnalyticsDashboard from "@/components/analytics/AnalyticsDashboard";

const AnalyticsPage: React.FC = () => {
  return <AnalyticsDashboard />;
};

export default AnalyticsPage;

// Create other page components (ClassifyPage, WardrobePage, etc.) following similar patterns...
